import TrainplanService from '@/services/TrainplanService'

export const get = () => TrainplanService.get('/2/migrated/plans')
